import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    MenuItem,
    TextField,
    Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from '../../../configs/messages';
import { ROUTES_LIST } from '../../../helpers/routesList';
import showMessage from '../../../helpers/showMessage';
import { useSnackbar } from 'notistack';
import { sendJsonData } from '../../../helpers/sendJsonData';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import { deleteData } from '../../../helpers/deleteData';
import { getDataItem } from '../../../helpers/getDataItem';
import {
    ADMIN_TYPES,
    ADMIN_TYPES_FOR_ADMIN,
    USER_ROLES,
} from '../../../configs/constants';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { getDataList } from '../../../helpers/getDataList';
import { useAuth } from '../../providers/AuthProvider';

export default function CmsUserForm({ isEdit }) {
    const [errors, setErrors] = useState({});
    const [showDeleteValidation, setShowDeleteValidation] = useState(false);
    const [initialData, setInitialData] = useState({
        name: '',
        email: '',
        role: '',
        password: '',
        confirmationPassword: '',
        channelId: '',
    });
    console.log("initialData=>",initialData)
    const [channelList, setChannelList] = useState([]);

    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();

    const { id } = useParams();
    const { user } = useAuth();

    let submitUrl = 'cms-users';
    if (isEdit) {
        submitUrl += `/${id}`;
    }

    useEffect(() => {
        let isActive = true;


        getDataList('channel')
            .then((response) => {
                if (isActive) {
                    const allChannel = response.data?.data;
                    if (allChannel.length === 1) {
                        setInitialData({
                            ...initialData,
                            ['channelId']: allChannel[0].id,
                        });
                    }
                    setChannelList(response.data?.data);
                }
            })
            .catch((error) => {
                const message = error.response?.data?.message
                    ? error.response.data.message
                    : error.message;
                showMessage(message, enqueueSnackbar, 'error');
            });

        if (!isEdit) {
            return () => (isActive = false);
        }

        // Get data if form type is edit
        getDataItem(submitUrl)
            .then(({ data }) => {
                if (isActive) {
                    delete data.data?.id;

                    data.data['channelId'] = data.data?.channel.id;
                    setInitialData(data.data);
                }
            })
            .catch((error) => {
                console.error(error);
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });

        return () => (isActive = false);
    }, []);

    const validate = () => {
        let tempErrors = { ...errors };
        const requiredMessage = ERROR_MESSAGES.FILL_THE_FIELD;
        if ('name' in initialData) {
            tempErrors.name = initialData.name ? '' : requiredMessage;
        }
        if ('email' in initialData) {
            tempErrors.email = initialData.email ? '' : requiredMessage;
        }
        if ('role' in initialData) {
            tempErrors.role = initialData.role ? '' : requiredMessage;
        }
        if ('password' in initialData) {
            tempErrors.password = initialData.password ? '' : requiredMessage;
        }
        if ('confirmationPassword' in initialData) {
            tempErrors.confirmationPassword = initialData.confirmationPassword
                ? ''
                : requiredMessage;
        }
        if (initialData.password !== initialData.confirmationPassword) {
            tempErrors.password =
                'Нууц үг болон Баталгаажуулах нууц үг тохирохгүй байна';
            tempErrors.confirmationPassword =
                'Нууц үг болон Баталгаажуулах нууц үг тохирохгүй байна';
        }

        setErrors({
            ...tempErrors,
        });

        return tempErrors;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        console.log("value==>", value)
        setInitialData({
            ...initialData,
            [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const tempErrors = validate();

        for (const key in tempErrors) {
            if (tempErrors[key]) {
                showMessage(
                    ERROR_MESSAGES.FILL_THE_FORM,
                    enqueueSnackbar,
                    'error',
                );
                return;
            }
        }

        const requestBody = Object.assign({}, initialData);

        if (isEdit) {
            delete requestBody.email;
        }
console.log("requestBody==:>",requestBody)
        sendJsonData(requestBody, submitUrl, isEdit)
            .then(() => {
                showMessage(SUCCESS_MESSAGES.ADDED_DATA, enqueueSnackbar);
                history.push(ROUTES_LIST.cmsUserList);
            })
            .catch((error) => {
                console.error(error);
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });
    };

    const handleDelete = () => {
        deleteData(submitUrl)
            .then(() => {
                showMessage(SUCCESS_MESSAGES.DELETED_DATA, enqueueSnackbar);
                history.push(ROUTES_LIST.cmsUserList);
            })
            .catch((error) => {
                console.error(error);
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });
    };
    const isAdmin = () => {
        return user?.role === USER_ROLES.ADMIN;
    };

    return (
        <>
            <form
                onSubmit={handleSubmit}
                autoComplete="false"
                className="user-form"
            >
                <Grid
                    container
                    direction="column"
                    spacing={2}
                    sx={{ width: '100%' }}
                >
                    <Grid
                        item
                        container
                        spacing={2}
                        direction="column"
                        sx={{ width: '100%' }}
                    >
                        <Grid item>
                            <TextField
                                value={initialData.name}
                                variant="standard"
                                label="Нэр"
                                fullWidth
                                name="name"
                                onChange={handleInputChange}
                                error={Boolean(errors.name)}
                                helperText={errors.name}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                value={initialData.email}
                                variant="standard"
                                label="И-мэйл"
                                fullWidth
                                type="email"
                                name="email"
                                onChange={handleInputChange}
                                error={Boolean(errors.email)}
                                helperText={errors.email}
                                disabled={isEdit}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                fullWidth
                                id="demo-simple-select"
                                variant="standard"
                                select
                                value={initialData.role}
                                label="CMS эрх"
                                onChange={handleInputChange}
                                name="role"
                                error={Boolean(errors.role)}
                                helperText={errors.role}
                            >
                                <MenuItem value="">
                                    <em>Сонго</em>
                                </MenuItem>
                                {isAdmin()
                                    ? ADMIN_TYPES_FOR_ADMIN.map((type) => (
                                          <MenuItem
                                              key={type.type}
                                              value={type.type}
                                          >
                                              {type.name}
                                          </MenuItem>
                                      ))
                                    : ADMIN_TYPES.map((type) => (
                                          <MenuItem
                                              key={type.type}
                                              value={type.type}
                                          >
                                              {type.name}
                                          </MenuItem>
                                      ))}
                            </TextField>
                        </Grid>
                        <Grid item>
                            <TextField
                                fullWidth
                                id="demo-simple-select"
                                variant="standard"
                                select
                                value={initialData.channelId}
                                label="Байгууллага"
                                onChange={handleInputChange}
                                name="channelId"
                                error={Boolean(errors.channelId)}
                                helperText={errors.channelId}
                            >
                                <MenuItem value="">
                                    <em>Сонго</em>
                                </MenuItem>
                                {channelList.map((type) => (
                                    <MenuItem key={type.id} value={type.id}>
                                        {type.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item>
                            {isEdit && (
                                <p
                                    style={{
                                        fontSize: '12px',
                                        marginTop: '15px',
                                        marginBottom: '0',
                                        color: '#888',
                                    }}
                                >
                                    Нууц үг солихгүй бол талбарыг хоосон орхино.
                                </p>
                            )}
                            <TextField
                                value={initialData.password}
                                variant="standard"
                                label="Нууц үг"
                                fullWidth
                                type="password"
                                name="password"
                                onChange={handleInputChange}
                                error={Boolean(errors.password)}
                                helperText={errors.password}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                value={initialData.confirmationPassword}
                                variant="standard"
                                label="Баталгаажуулах нууц үг"
                                fullWidth
                                type="password"
                                name="confirmationPassword"
                                onChange={handleInputChange}
                                error={Boolean(errors.confirmationPassword)}
                                helperText={errors.confirmationPassword}
                            />
                        </Grid>

                        <Grid
                            item
                            container
                            direction="row"
                            justifyContent="space-between"
                        >
                            <Grid item>
                                <Button
                                    variant="contained"
                                    color="warning"
                                    type="button"
                                    onClick={() => history.goBack()}
                                >
                                    <ArrowBackIcon />
                                    <Typography style={{ marginLeft: '10px' }}>
                                        Буцах
                                    </Typography>
                                </Button>
                            </Grid>
                            <Grid item>
                                {isEdit && (
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        type="button"
                                        onClick={() =>
                                            setShowDeleteValidation(true)
                                        }
                                    >
                                        <DeleteOutlineIcon />
                                        <Typography
                                            style={{ marginLeft: '10px' }}
                                        >
                                            Устгах
                                        </Typography>
                                    </Button>
                                )}
                                <Button
                                    color="success"
                                    style={{ marginLeft: '10px' }}
                                    type="submit"
                                    variant="outlined"
                                >
                                    <SaveAltIcon />
                                    <Typography style={{ marginLeft: '10px' }}>
                                        Хадгалах
                                    </Typography>
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </form>

            {isEdit && (
                <Dialog
                    open={showDeleteValidation}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        Та энэхүү мэдээллийг устгахыг хүсэж байна уу?
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Та энэ мэдээллийг устгахыг хүсэж байвал
                            &apos;Тийм&apos; товчийг дарна уу.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setShowDeleteValidation(false)}>
                            Болих
                        </Button>
                        <Button color="error" onClick={handleDelete} autoFocus>
                            Тийм
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
}
